<template>
  <AppHeaderDropdown
    right
    no-caret
  >
    <template slot="header">
      <div @click="resetearNotificaciones">
        <i class="icon-bell"></i>
        <b-badge
          v-if="cantNotificacionesNuevas > 0"
          pill
          variant="danger"
        > {{ cantNotificacionesNuevas }}</b-badge>
      </div>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="dropdown-menu-lg text-center"><strong>Mis notificaciones</strong></b-dropdown-header>
      <b-dropdown-item v-for="notificacion in notificaciones">
        {{ notificacion.mensaje }}
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  name: "DefaultHeaderDropdownNotif",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {};
  },
  methods: {
    resetearNotificaciones() {
      this.$store.dispatch("setNotificacionesNuevas", 0);
    }
  },
  computed: {
    notificaciones() {
      return this.$store.getters.getNotificaciones;
    },

    cantNotificacionesNuevas() {
      return this.$store.getters.getCantNotificacionesNuevas;
    }
  }
};
</script>
